export default {
  "common": {
    "accessManagement": "Access Management",
    "action": "Action",
    "actions": "Actions",
    "activate_link": "Activate link",
    "active": "Active",
    "add_column": "Add column",
    "add_dependency": "Add dependency",
    "add_field": "Add field",
    "add_group": "Add Group",
    "add_group_feature_description": "Select the group you want to add to the feature",
    "add_group_feature_title": "Add group to feature",
    "add_initiative": "Add initiative",
    "add_one_option_per_line": "Add one option per line",
    "add_option": "Add option",
    "add_permission": "Add permission",
    "add_question": "Add question",
    "add_related_field": "Add related field",
    "add_row": "Add row",
    "add_rule": "Add rule",
    "add_section": "Add section",
    "add_to_group": "Add to group",
    "add_user": "Add User",
    "add_user_feature_description": "Select the user you want to add to the feature",
    "add_user_feature_title": "Add user to feature",
    "add_user_to_group": "Add user to group",
    "add_user_to_initiative": "Add user to initiative",
    "add_workflow": "Add Workflow",
    "added_at": "Added at",
    "administrators": "Administrators",
    "alias": "Alias",
    "alias_format": "The alias must start with a lowercase letter or underscore and contain only lowercase letters, numbers, or underscores",
    "alias_invalid_others_suffix": "The alias cannot end with \"_others\"",
    "alias_invalid_reserved_word": "Invalid alias. It cannot be a reserved word.",
    "alias_max_length": "The alias must be at most 100 characters long",
    "alias_min_length": "The alias must be at least 3 characters long",
    "all": "All",
    "all_done": "All done, thank you!",
    "all_relations": "All",
    "allow_others": "Add others?",
    "allow_typed_signature": "Allow typed signature?",
    "and": "And",
    "annex_from_device": "Upload from device",
    "anom_user": "Anonymous",
    "apply_filter": "Apply",
    "apply_filter_count_one": "Apply ({{count}})",
    "apply_filter_count_other": "Apply ({{count}})",
    "apply_rules": "Apply rules",
    "ascending_relations": "Ascending",
    "attributes": "Attributes",
    "audio_duration": "Audio duration",
    "audio_input_accepted_formats": "MP3, WAV, M4A or OGG · max 10MB",
    "audio_input_delete_confirm_message": "This recording will be permanently deleted. Do you want to continue?",
    "audio_input_delete_confirm_title": "Delete recording?",
    "audio_input_discard_confirm_message": "Recording again will discard the current audio. Do you want to continue?",
    "audio_input_discard_confirm_title": "Discard recording?",
    "audio_recording_too_long": "The recording was automatically stopped at {{seconds}} seconds",
    "audio_recording_too_short": "The recording must be at least {{seconds}} seconds long",
    "audio_uploading_helper_text": "Uploading audio... don't close the form.",
    "audio_uploading_step_label": "Uploading",
    "authentication": "Authentication",
    "back": "Back",
    "back_to_feature": "Back to Feature",
    "back_to_home": "Back to home",
    "back_to_initiative": "Back to initiative",
    "begins_with": "Begins with",
    "between": "Between",
    "both_filters_cannot_be_empty": "Both filters cannot be empty",
    "building": "Building...",
    "business": "Business",
    "business_created_successfully": "Business created successfully.",
    "business_data": "Business data",
    "business_name": "Business name",
    "business_required": "Business is required",
    "business_updated_successfully": "Business updated successfully.",
    "businesses": "Businesses",
    "businesses_count_one": " · {{count}} business",
    "businesses_count_other": " · {{count}} businesses",
    "cancel": "Cancel",
    "cannot_delete_group_with_users": "You cannot delete the group because it has users",
    "cannot_remove_last_section": "Cannot Remove Last Section",
    "cannot_save_empty_filter": "Cannot save an empty filter",
    "cannot_save_empty_form": "Cannot Save Empty Form",
    "carousel_go_to_item": "Go to item {{index}}",
    "change_password": "Change password",
    "change_user_password": "Change user password",
    "change_user_password_description": "Create a temporary password for the user, which must be changed on next login.",
    "choose_an_attribute_from_the_list_above": "Choose a field from the list above",
    "choose_field_from_table": "Choose a field from the data table",
    "choose_layout_link": "Choose the layout for which you want to create the link:",
    "clean_unsaved_collect": "Clear unsaved collection",
    "clear_filter": "Clear",
    "click_here_to_view": "Open or download in new tab",
    "CNPJ_invalid": "CNPJ is invalid",
    "CNPJ_max_length_18": "CNPJ must be at most 18 characters long",
    "CNPJ_min_length_18": "CNPJ must be at least 18 characters long",
    "CNPJ_required": "CNPJ is required",
    "code_editor_collapsed_image": "image · {{size}} KB",
    "collapse_all": "Collapse all",
    "collect": "Collect",
    "collect_back_button": "Previous",
    "collect_concluded_button": "Conclude form",
    "collect_created_confirmation": "Do you want to go back to the list or create a new collect?",
    "collect_created_title": "Collect saved successfully",
    "collect_date_time": "{{date}} at {{hours}}:{{minutes}}",
    "collect_days_ago_one": "{{count}} day ago",
    "collect_days_ago_other": "{{count}} days ago",
    "collect_delete_in_use_description": "This collect cannot be deleted because it is being used in another feature.",
    "collect_delete_in_use_title": "Collect in use",
    "collect_hours_ago_one": "{{count}} hour ago",
    "collect_hours_ago_other": "{{count}} hours ago",
    "collect_just_now": "Just now",
    "collect_minutes_ago_one": "{{count}} minute ago",
    "collect_minutes_ago_other": "{{count}} minutes ago",
    "collect_months_ago_one": "{{count}} month ago",
    "collect_months_ago_other": "{{count}} months ago",
    "collect_next_button": "Next section",
    "collect_section_paginate": "Section",
    "collect_section_paginate_separator": "of",
    "collect_versions": "Collect versions",
    "collect_years_ago_one": "{{count}} year ago",
    "collect_years_ago_other": "{{count}} years ago",
    "collect(s)": "Collect(s)",
    "collected_by": "Collected by {{name}}",
    "collects": "Collects",
    "collects_count_one": "{{count}} collect",
    "collects_count_other": "{{count}} collects",
    "collects_label_one": "collect",
    "collects_label_other": "collects",
    "collects_last_7_days": "Collections 7d",
    "collects_point_to_this_one": "{{count}} collect points to this one",
    "collects_point_to_this_other": "{{count}} collects point to this one",
    "column_size": "Column size",
    "condition": "Condition",
    "condition_contains": "Contains",
    "condition_equal": "Equal",
    "condition_greater_than": "Greater than",
    "condition_less_than": "Less than",
    "condition_multiple": "Multiple",
    "configurations": "Configurations",
    "configure": "Configure",
    "configure_attribute": "Configure attribute",
    "confirm": "Confirm",
    "confirm_action": "Confirm status change",
    "confirm_delete_feature": "Are you sure you want to delete this feature?",
    "confirm_password": "Confirm password",
    "confirm_remove_dependencies_description": "When changing this field, the current dependencies will be removed. Are you sure you want to continue?",
    "confirm_remove_row_description": "Do you really want to remove this row? The fields it contains will be removed.",
    "confirm_remove_section_description": "Do you really want to remove this section? The fields it contains will be removed.",
    "confirm_update_field_in_published_layout": "Do you really want to update this field?",
    "connect_question": "Connect question",
    "consent_text_min_length": "Consent text must be at least 5 characters long",
    "consent_text_required": "Consent text is required",
    "contains": "Contains",
    "contains_file": "Contains file",
    "copy_default_view": "Copy default view",
    "CPF_invalid": "CPF is invalid",
    "CPF_min_length_11": "CPF must be at least 11 characters long",
    "create": "Create",
    "create_business": "Create Business",
    "create_field": "Create field",
    "create_group": "Create group",
    "create_initiative": "Create initiative",
    "create_new_collect": "Create new collect",
    "create_user": "Create user",
    "created_at": "Created at",
    "created_at_label": "Created {{date}}",
    "created_by": "Created by",
    "created_with": "Form created with",
    "currency_symbol": "$",
    "custom_fields": "Custom fields",
    "customize_layout_attributes": "Customize layout and attributes",
    "dashboard": "Dashboard",
    "dashboard_link": "Dashboard link",
    "dashboard_link_placeholder": "https://app.powerbi.com/example",
    "data_collection": "Data collection",
    "data_information": "Data and information",
    "data_map": "Data map",
    "data_source": "Data source",
    "data_table": "Data table",
    "date_invalid": "The date must be in dd/mm/yyyy format",
    "DateTime_invalid": "The date and time must be in dd/mm/yyyy HH:mm format",
    "deactivate_link": "Deactivate link",
    "default_view": "Default view",
    "define_super_admin_permissions": "Define super admin permissions",
    "delete": "Delete",
    "delete_attribute": "Delete attribute",
    "delete_collect": "Do you really want to delete this collect?",
    "delete_dependency": "Delete dependency",
    "delete_feature": "Delete Feature",
    "delete_feature_confirmation_label": "Yes, I understand and want to delete this feature",
    "delete_feature_warning": "Warning: This action is irreversible. All data linked to this feature will be permanently removed.",
    "delete_initiative": "Delete initiative",
    "delete_initiative_confirmation": "Do you really want to delete this initiative?",
    "delete_option": "Delete option",
    "delete_permission": "Delete permission",
    "delete_permission_confirmation": "Do you really want to delete this permission?",
    "delete_workflow": "Delete workflow",
    "delete_workflow_description": "Are you sure you want to delete this workflow?",
    "dependencies": "Dependencies",
    "dependencies_count_one": "dependency ({{count}})",
    "dependencies_count_other": "dependencies ({{count}})",
    "descending_relations": "Descending",
    "description": "Description",
    "description_length_invalid": "Description must be at least 1 character long",
    "description_max_length": "Description must be at most 5000 characters long",
    "Description_max_length_3_800": "Description must be between 3 and 800 characters long",
    "description_min_length": "Description must be at least 1 character long",
    "description_min_length_3_800": "Description must be at least 3 characters long and at most 800 characters long",
    "description_required": "Description is required",
    "destination_initiative_required": "Destination initiative is required",
    "destination_required": "Destination is required",
    "disable_portfolio": "Disable portfolio",
    "discard": "Discard",
    "do_you_really_want_to_remove_the_email_template": "Do you really want to delete this email template?",
    "do_you_really_want_to_remove_the_group": "Do you really want to remove the group?",
    "download": "Download",
    "download_template": "Download Template",
    "draft_saved": "Draft saved",
    "drag_and_drop_file": "Drag and drop file",
    "drag_to_reorder": "Drag to reorder",
    "duplicate_feature": "Duplicate Feature",
    "duplicate_initiative": "Duplicate Initiative",
    "duplicate_section_title": "A section with this title already exists.",
    "edit": "Edit",
    "edit_and_delete": "Edit and Delete",
    "edit_feature": "Edit Feature",
    "edit_initiative": "Edit initiative",
    "edit_portfolio": "Edit portfolio",
    "edit_user": "Edit user",
    "editGroup": "Edit group",
    "email": "Email",
    "email_body": "Email body",
    "email_invalid": "Email is invalid",
    "email_required": "Email is required",
    "email_template_body": "Email body (HTML)",
    "email_template_body_required": "Email body is required",
    "email_template_code": "Code",
    "email_template_compatibility_warning": "Some HTML/CSS attributes and features may not work in every email client.",
    "email_template_create": "New template",
    "email_template_created_successfully": "Email template created successfully",
    "email_template_data": "Email template data",
    "email_template_deleted_successfully": "Email template deleted successfully",
    "email_template_edit": "Edit template",
    "email_template_edited_successfully": "Email template updated successfully",
    "email_template_locale": "Language",
    "email_template_locale_placeholder": "Select the language",
    "email_template_locale_required": "Language is required",
    "email_template_missing_variables": "Missing required variables: {{variables}}",
    "email_template_preview": "Preview",
    "email_template_preview_empty": "Fill in the email body to preview it",
    "email_template_preview_feature_example": "Example feature",
    "email_template_subject": "Subject",
    "email_template_subject_max_length": "Subject must have at most {{maxLength}} characters",
    "email_template_subject_required": "Subject is required",
    "email_template_unknown_variables": "Variables not allowed: {{variables}}",
    "email_template_updated_at": "Updated at",
    "email_template_variable_optional": "Optional variable",
    "email_template_variable_required_missing": "Required variable missing",
    "email_template_variable_required_present": "Required variable present",
    "email_template_variables": "Variables:",
    "email_templates": "Email templates",
    "email_templates_description": "Email templates used by this initiative's workflows.",
    "empty_layout": "Empty layout",
    "empty_section_title": "The section title cannot be empty",
    "enable_portfolio": "Enable portfolio",
    "enabled_required": "User status is required",
    "end": "End",
    "end_date": "End date",
    "ends_with": "Ends with",
    "enter_email": "Enter email",
    "enter_email_body": "Enter email body",
    "enter_field_description": "Enter a description for the field",
    "enter_field_name": "Enter the field name",
    "enter_new_password": "Enter new password",
    "enter_option_name": "Enter option name",
    "equals": "Equals",
    "error": "Error",
    "exampleEmail {{verb}} {{feature}}": "The following email is already sent by default, what you write in this field will be sent at the end of this message:\nA collect with ID # has been {{verb}} for the feature {{feature}}.",
    "executed_at": "Executed at",
    "exit": "Exit",
    "expand_all": "Expand all",
    "export_ascending_relations": "Ascending relationships",
    "export_data": "Export data",
    "export_data_success": "Request for export made successfully.",
    "export_descending_relations": "Descending relationships",
    "export_files": "Export collect files",
    "export_pdf": "Export PDF",
    "exports": "Exports",
    "feature": "Feature",
    "feature_created_successfully": "Feature created successfully.",
    "feature_data": "Feature data",
    "feature_enabled": "Feature enabled",
    "feature_name": "Feature name",
    "feature_published": "Feature published",
    "feature_updated_error": "Error updating feature",
    "feature_updated_success": "Feature updated successfully.",
    "features": "Features",
    "field": "Field",
    "field_created_successfully": "Field created successfully.",
    "field_description_max_length": "Field description must be at most 5000 characters long",
    "field_name_max_length": "Field name must be at most 250 characters long",
    "field_placeholder": "Field...",
    "field_required": "Field is required",
    "field_type_BIG_INT": "Integer number",
    "field_type_DATE": "Date",
    "field_type_DATETIME": "Date and time",
    "field_type_DECIMAL": "Decimal number",
    "field_type_FILE": "File",
    "field_type_GEOGRAPHICAL_MULTIPLE_POINT": "Multiple geographic points",
    "field_type_GEOGRAPHICAL_POINT": "Geographic point",
    "field_type_GEOGRAPHICAL_POLYGON": "Geographic polygon",
    "field_type_GEOGRAPHICAL_ROUTE": "Geographic route",
    "field_type_IMPORT_FIELD": "Import a feature",
    "field_type_INFO_TEXT": "Information text",
    "field_type_LONG_TEXT": "Long text",
    "field_type_MATRIZ": "Matrix",
    "field_type_MULTIPLE_LIST": "Multiple selection box",
    "field_type_required": "Field type is required",
    "field_type_TERM": "Consent term",
    "field_type_TEXT": "Short text",
    "field_type_TIME": "Time",
    "field_type_UNIQUE_LIST": "Single selection box",
    "field_updated_successfully": "Field updated successfully.",
    "fields_to_export": "Fields to export",
    "file": "File",
    "file_cannot_be_null_select_file": "The file cannot be null. Please select a file to upload.",
    "file_name": "File name",
    "file_preview_not_supported": "File preview is not supported",
    "filter_business": "Filter business",
    "filter_by_feature": "Filter by Feature",
    "finish": "Finish",
    "finished_count": "Finished",
    "finished_rate": "Completion Rate",
    "form_answered_successfully": "Your response to the <b>{{featureName}}</b> form was successfully submitted and is already registered.",
    "full_screen": "Full screen",
    "generate_autoapply": "Generate Autoapply",
    "generate_link": "Generate link",
    "generated_automatically": "Generated automatically",
    "go_to_collects_list": "Back to the list",
    "go_to_decisio": "Go to Decisio",
    "greater_than_or_equal_to": "Greater than or equal to",
    "group": "Group",
    "group_added_successfully": "Group added successfully.",
    "group_created_successfully": "Group created successfully.",
    "group_data": "Group data",
    "group_deleted_successfully": "Group deleted successfully.",
    "group_edited_successfully": "Group edited successfully.",
    "group_name": "Group name",
    "group_required": "Group is required",
    "groups": "Groups",
    "if_the_answer_is": "If the answer is",
    "image_exceeded_size_limit": "The image has exceeded the size limit of {{size}}mb.",
    "image_gallery": "Image Gallery",
    "import_data_success": "Data imported successfully.",
    "import_file": "Import file",
    "import_finish": "Import finish",
    "import_line_max_length": "The lines must have a maximum length of 255 characters.",
    "import_options": "Import options",
    "imported_data": "Imported data",
    "imports": "Imports",
    "in_seconds": "In seconds",
    "inactive": "Inactive",
    "info_text_min_length": "Info text must be at least 5 character long",
    "info_text_required": "Info text is required",
    "initiative": "Initiative",
    "initiative_created_successfully": "Initiative created successfully.",
    "initiative_deleted_successfully": "Initiative deleted successfully.",
    "initiative_edited_successfully": "Initiative edited successfully.",
    "initiative_features": "Initiative features",
    "initiative_imports_and_exports": "Imports and exports",
    "initiative_imports_and_exports_description": "Upload data or extract collects as XLSX.",
    "initiative_name": "Initiative name",
    "initiative_name_max_length": "Initiative name must be at most 50 characters long",
    "initiative_successfully_duplicated": "Initiative duplicated successfully.",
    "initiatives": "Initiatives",
    "initiatives_count_one": "{{count}} initiative",
    "initiatives_count_other": "{{count}} initiatives",
    "integer_invalid": "Integer is invalid",
    "invalid_email": "Invalid email",
    "invalid_option": "Invalid option",
    "language_en": "English",
    "language_es": "Spanish",
    "language_pt_br": "Portuguese (Brazil)",
    "last_collect": "Last collection",
    "last_collects": "Latest collections",
    "last_collects_load_error": "Could not load the latest collections",
    "layout_saved_successfully": "Layout saved successfully.",
    "less_than_or_equal_to": "Less than or equal to",
    "like_required": "Search term is required",
    "link": "Link",
    "link_collect": "Link collect",
    "link_feature": "Link feature",
    "link_features": "Link features",
    "link_invalid": "Invalid link",
    "linked_features": "Linked features",
    "load_more": "Load more",
    "load_more_collects_one": "Load {{count}} more of {{total}}",
    "load_more_collects_other": "Load {{count}} more of {{total}}",
    "load_more_results": "Load more results",
    "loading_layout": "Loading layout...",
    "loading_more": "Loading...",
    "location": "Location",
    "logo": "Logo",
    "logo_required": "Logo is required",
    "lookup": "lookup",
    "main_fields": "Main fields",
    "main_tab": "Main",
    "manage_groups_permissions": "Manage groups that have permissions on this feature.",
    "manage_users_permissions": "Manage users who have permissions on this feature.",
    "manage_users_with_admin_permissions": "Manage users with admin permissions on this initiative.",
    "matrices": "Matrices",
    "matrix": "Matrix",
    "matrix_fields": "matrix fields",
    "matriz_field": "Matrix Field",
    "matriz-create": "Create matrix",
    "matriz-delete": "Delete matrix",
    "matriz-update": "Update matrix",
    "max_duration": "Max duration",
    "max_duration_cannot_be_greater_than_600": "Max duration cannot be greater than 600 seconds",
    "maximum_value": "Maximum value",
    "menu_logout_confirm_description": "You will be signed out of your account and any unsaved changes will be lost. Do you want to continue?",
    "menu_logout_confirm_title": "Exit Decisio",
    "microphone_access_denied": "Microphone access was denied. Please allow microphone access to record audio.",
    "min_duration": "Min duration",
    "min_value_cannot_be_greater_than_max_value": "Minimum value cannot be greater than maximum value",
    "minimum_value": "Minimum value",
    "mobile": "Mobile",
    "monetary_subtype_not_apply_to_text": "Monetary subtype does not apply to text",
    "more_fields_one": "+ {{count}} field",
    "more_fields_other": "+ {{count}} fields",
    "more_filled_fields_one": "+ {{count}} filled field",
    "more_filled_fields_other": "+ {{count}} filled fields",
    "most_recent": "Most recent",
    "name": "Name",
    "name_max_length": "Name must be at most {{maxLength}} characters",
    "name_min_length": "Name must be at least 3 characters",
    "name_min_length_3": "Name must be at least 3 characters",
    "name_required": "Name is required",
    "new_collect": "New collect",
    "new_collect_no_layout": "No published layout available for the target feature",
    "new_export": "New export",
    "new_feature": "New feature",
    "new_import": "New import",
    "next": "Next",
    "no": "No",
    "no_attribute_selected": "No attribute selected",
    "no_audits_found": "No audits found.",
    "no_businesses_found": "No businesses found",
    "no_collect_found": "No collection found",
    "no_collect_links": "There are no collection links for this feature. Returning...",
    "no_collects": "No collections",
    "no_data_found": "No data found.",
    "no_email_templates_found": "No email templates found.",
    "no_exports_found": "No exports found.",
    "no_features_found": "No features found.",
    "no_fields_found": "No fields found",
    "no_group_permission": "No group has permission for this feature.",
    "no_groups_found": "No groups found",
    "no_imports_found": "No imports found.",
    "no_initiatives_found": "No initiatives found",
    "no_linked_features": "No linked features",
    "no_permission": "No permission",
    "no_published_layout_redirect": "There is no published layout for this feature. Redirecting...",
    "no_records_found": "No records found",
    "no_related_fields_found": "No related fields found",
    "no_user_permission": "No user has permission for this feature.",
    "no_users_found": "No users found",
    "no_workflows_found": "No workflows found",
    "none": "None",
    "not_authorized": "Access not authorized!",
    "not_collect_found": "No collections found",
    "not_contains": "Does not contain",
    "not_equals": "Not equal to",
    "notification": "Notification",
    "on_change_section": "When changing the reference matrix or section type, current settings will be lost. Are you sure?",
    "on_close": "Close",
    "only_audio_files": "Only audio files are allowed",
    "only_images_allowed": "Only images are allowed",
    "only_images_as_logo": "The business accepts only images of type .png, .jpeg, .gif or .webapp as a logo.",
    "open": "Open",
    "open_collect": "Open collect",
    "open_count": "Opens",
    "open_in_power_bi": "Open in Power BI",
    "open_initiative": "Open initiative",
    "operator": "Operator",
    "operator_required": "Operator is required",
    "option_line_placeholder": "Enter one option per line",
    "option_name_required": "The option name is required",
    "or": "Or",
    "order": "Order",
    "order_by": "Order by",
    "other": "Others",
    "page_not_found": "Page not found",
    "page_not_found_description": "The page you are looking for does not exist.",
    "pagination": "Pagination",
    "participants": "Participants",
    "password": "Password",
    "password_changed_successfully": "Password changed successfully.",
    "password_max_length": "Password must be at most 40 characters",
    "password_min_length": "Password must be at least 4 characters",
    "password_required": "Password is required",
    "passwords_must_match": "Passwords must match",
    "past": {
      "create": "created",
      "delete": "deleted",
      "update": "updated"
    },
    "pause": "Pause",
    "paused_status": "Paused",
    "permission": "Permission",
    "permission_added_success": "Permission added successfully.",
    "permission_deleted_successfully": "Permission deleted successfully.",
    "permissions_groups": "Permissions of Groups",
    "permissions_user": "Permissions of Users",
    "Phone_max_length_15": "Phone must be at most 15 characters long",
    "Phone_min_length_14": "Phone must be at least 14 characters long",
    "placeholder_editor": "Type or paste your content here!",
    "platform": "Platform",
    "platform_required": "You must define the platform",
    "Point_invalid": "Point is invalid",
    "Point_invalid_range": "Point is invalid range",
    "point_min_length_1": "At least one point must be informed",
    "portfolio": "Portfolio",
    "positive_invalid": "Positive number is invalid",
    "power_bi": "Power BI",
    "preview_fields": "Preview fields",
    "previous": "Previous",
    "processing": "Processing",
    "publish": "Publish",
    "recent": "Recent",
    "record_audio": "Record audio",
    "recorded_now": "Recorded now",
    "recording_status": "Recording",
    "region_city_or_neighborhood ": "Region, city or neighborhood",
    "registration": "Registration",
    "related_field": "Related field",
    "relationships": "Relationships",
    "remove": "Remove",
    "remove_rule": "Remove rule",
    "remove_user": "Do you really want to remove the user?",
    "remove_user_from_group": "Remove user from group",
    "required_field": "Required field?",
    "required_matrix": "Required matrix",
    "response": "Response",
    "response_value": "Response value",
    "responsible_data": "Responsible data",
    "responsible_email": "Responsible email",
    "Responsible_email_invalid": "Responsible email is invalid",
    "Responsible_email_required": "Responsible email is required",
    "responsible_name": "Responsible name",
    "responsible_name_max_length": "Responsible name must be at most 5000 characters long",
    "Responsible_name_max_length_100": "Responsible name must be at most 100 characters",
    "responsible_name_min_length": "Responsible name must be at least 1 character long",
    "Responsible_name_min_length_3": "Responsible name must be at least 3 characters",
    "Responsible_name_required": "Responsible name is required",
    "responsible_phone": "Responsible phone",
    "responsible_phone_max_length": "Responsible phone must be at most 15 characters long",
    "Responsible_phone_max_length_15": "Responsible phone must be at most 15 characters",
    "responsible_phone_min_length": "Responsible phone must be at least 14 characters long",
    "Responsible_phone_min_length_15": "Responsible phone must be at least 14 characters",
    "Responsible_phone_required": "Responsible phone is required",
    "restore_unsaved_collect": "An unsaved collection was found. Do you want to restore it?",
    "resume": "Resume",
    "return_previous_page": "Return to previous page",
    "return_to_businesses_management": "Return to business management",
    "return_to_destination": "Return to {{destination}}",
    "return_to_email_templates": "Back to email templates",
    "return_to_group_management": "Return to group management",
    "return_to_initiative": "Return to initiative",
    "return_to_initiative_management": "Return to initiative management",
    "return_to_initiatives": "Return to initiatives",
    "return_to_initiatives_management": "Return to initiatives management",
    "return_to_user_management": "Return to user management",
    "save": "Save",
    "save_changes": "Save changes",
    "saved": "Saved",
    "saving": "Saving...",
    "search_available_when_loaded": "Search available once loading finishes",
    "search_businesses": "Search businesses",
    "search_by_code_or_label": "Search by code or label",
    "search_collects": "Search collects",
    "search_collects_error": "Could not load the search results",
    "search_collects_subtitle_one": "Found in {{count}} feature",
    "search_collects_subtitle_other": "Found in {{count}} features",
    "search_collects_title_one": "{{count}} collect for “{{search}}”",
    "search_collects_title_other": "{{count}} collects for “{{search}}”",
    "search_features": "Search Features",
    "search_fields": "Search fields",
    "search_groups": "Search groups",
    "search_in_initiative": "Search in initiative",
    "search_initiative": "Search initiative",
    "search_min_length": "Type at least {{min}} characters to search",
    "search_question": "Search question",
    "search_users": "Search users",
    "second_value_required": "Second value is required",
    "section": "Section",
    "section_has_invalid_fields": "The section has invalid fields.",
    "section_image": "Section image",
    "section_required": "Section is required",
    "section_title": "Section title",
    "sections": "Sections",
    "see_in_collect": "See in collect",
    "select": "Select",
    "select_a_feature": "Select a feature.",
    "select_a_value": "Select a value",
    "select_action_type": "Select action type",
    "select_all": "Select all",
    "select_an_import_file": "Select an import file.",
    "select_an_option": "Select an option",
    "select_at_least_one_item": "Select at least one item",
    "select_at_least_one_option": "Select at least one option",
    "select_attribute": "Select attribute",
    "select_collect_required": "Selecting a collect is required",
    "select_condition": "Select a condition",
    "select_condition_required": "Condition is required",
    "select_feature": "Select feature",
    "select_feature_required": "Feature is required",
    "select_features_to_link": "You can select up to 3 fields from this feature to generate a preview of the collection to be linked.",
    "select_field": "Select field",
    "select_field_min_options": "The selection field must have at least two options.",
    "select_field_subtype": "Select the subtype",
    "select_field_type": "Select the field type",
    "select_filters": "Select filters",
    "select_group_placeholder": "Select a group",
    "select_group_required": "Group is required",
    "select_initiative": "Select initiative",
    "select_initiative_required": "Initiative is required",
    "select_matriz_field": "Select the matrix field",
    "select_max_three_fields": "Select at most 3 fields",
    "select_permission": "Select permission",
    "select_permission_level": "Select permission level",
    "select_platform_required": "Platform is required",
    "select_preview_fields_tooltip": "You can select up to 3 fields from this feature to generate a preview of the collection to be linked.",
    "select_the_group_you_want_to_add_the_user_to": "Select the group you want to add the user to",
    "select_user": "Select user",
    "select_user_placeholder": "Select a user",
    "select_user_required": "User is required",
    "select_user_to_add_to_group": "Select the user you want to add to the group",
    "select_user_to_add_to_initiative": "Select the user you want to add to the initiative",
    "selected_count_one": "{{count}} selected",
    "selected_count_other": "{{count}} selected",
    "selected_items": "selected items",
    "self_applied_link": "Self-Applied Link",
    "self_applied_session_expired": "Your session has expired. Open the link again and enter a new code to continue.",
    "send_new_answer": "Send new answer",
    "sensitive_data": "Sensitive data",
    "shared_preference": "Switch to personal preferences",
    "show_less": "Show less",
    "show_more_count_one": "Show {{count}} more",
    "show_more_count_other": "Show {{count}} more",
    "showing_initiatives_one": "Showing {{loaded}} of {{count}} initiative",
    "showing_initiatives_other": "Showing {{loaded}} of {{count}} initiatives",
    "signature_add_title": "Add signature",
    "signature_clear": "Clear",
    "signature_consent_desktop": "I declare this is my electronic signature and agree to use it to sign this form.",
    "signature_date_label": "Date",
    "signature_description": "Sign with your mouse, touch the screen, or type your full name.",
    "signature_description_no_typed": "Sign with your mouse or touch the screen.",
    "signature_draw_above_line": "Sign above the line",
    "signature_empty_subtitle": "PNG generated automatically and attached to the response",
    "signature_empty_title": "No signature recorded",
    "signature_full_name": "Full name",
    "signature_full_name_document_placeholder": "As shown on the document",
    "signature_image_alt": "Signature",
    "signature_location_label": "Location",
    "signature_name_label": "Name",
    "signature_name_too_long": "Name must have at most 255 characters",
    "signature_name_too_short": "Name must have at least 3 letters",
    "signature_redo": "Redo",
    "signature_remove": "Remove",
    "signature_remove_confirm_message": "This signature will be permanently removed. Do you want to continue?",
    "signature_remove_confirm_title": "Remove signature?",
    "signature_sample_name": "Your name",
    "signature_sign": "Sign",
    "signature_tab_draw": "Draw",
    "signature_tab_type": "Type",
    "start": "Start",
    "start_date": "Start date",
    "start_date_cannot_be_greater_than_end_date": "Start date cannot be greater than end date",
    "start_write_count": "Started",
    "status": "Status",
    "status_feature_updated_successfully": "Status of feature {{featureName}} updated successfully",
    "strict_section_navigate": "Strict section navigation",
    "sub_type": "Subtype",
    "subtype_AUDIO": "Audio",
    "subtype_CNPJ": "CNPJ",
    "subtype_CPF": "CPF",
    "subtype_HIPERLINK": "Link",
    "subtype_MAIL": "Email",
    "subtype_MONEY_VALUE": "Monetary value",
    "subtype_PHONE": "Phone",
    "subtype_SIGNATURE": "Signature",
    "subtypes_not_apply_to_decimal": "Subtypes do not apply to decimal",
    "success": "Success",
    "successfully_duplicated": "Successfully duplicated",
    "successfully_removed": "Successfully removed",
    "summary_active_collectors": "Active collectors",
    "summary_files": "Files",
    "summary_files_description": "attachments and audios sent",
    "summary_in_last_7_days": "in the last 7 days",
    "summary_last_7_days": "Last 7 days",
    "summary_last_collect_at": "last at {{time}}",
    "summary_no_collects_today": "no collects today",
    "summary_today": "Today",
    "summary_total_collects": "Total collects",
    "summary_vs_previous_month": "{{value}} vs. previous month",
    "summary_vs_previous_week": "{{value}} vs. previous week",
    "super_admin": "Super admin",
    "super_admin_business_required": "Business permission level is required",
    "super_admin_initiative_required": "Initiative permission level is required",
    "super_admin_permissions": "Super admin permissions",
    "super_admin_required": "Super admin status is required",
    "super_admin_user_required": "User permission level is required",
    "sync_explanation": "When syncing, you replace your current preferences with the default preferences.",
    "sync_preference_unavailable": "You already have the default preferences",
    "template": "Template",
    "template_and_import": "Template and import",
    "text_max_length_255": "Text must be at most 255 characters long",
    "text_max_length_3000": "Text must be at most 3000 characters long",
    "text_min_length_1": "Text must be at least 1 character long",
    "text_min_length_3": "Text must be at least 3 characters long",
    "this_action_cannot_be_undone": "This action cannot be undone.",
    "time_format_expected": "Invalid time format",
    "Time_invalid": "Time is invalid",
    "title_initiative_data": "Initiative data",
    "totp_error": "Invalid code",
    "totp_instruction": "Insert the authentication code",
    "trigger": "Trigger",
    "trigger_type": "Trigger Type",
    "trigger_type_required": "Trigger type is required",
    "type": "Type",
    "type_required": "Type is required",
    "update": "Update",
    "update_version": "Update version",
    "update_version_confirm_description": "Are you sure you want to update the feature version? This action may add new validations or remove previously registered fields.",
    "updated_at_label": "Updated {{date}}",
    "upload": "Upload",
    "user": "User",
    "user_added_successfully": "User added successfully.",
    "user_created_successfully": "User created successfully.",
    "user_data": "User data",
    "user_edited_successfully": "User edited successfully.",
    "user_preference": "Switch to default preferences",
    "user_profile": "User profile",
    "user_removed_from_group_successfully": "User removed from group successfully.",
    "user_required": "User is required",
    "user_status": "User status",
    "users": "Users",
    "users_found": "No users found",
    "valid_link_required": "Valid link is required",
    "valid_powerbi_link_required": "Valid Power BI link is required",
    "value": "Value",
    "value_must_be_a_number": "Value must be a number",
    "value_required": "Value is required",
    "version": "Version",
    "video_tag_not_supported": "Video display is not supported",
    "view": "View",
    "view_analytics": "View analytics",
    "view_version": "View version",
    "view_workflow": "View workflow",
    "visualizer_error": "Error displaying the audio visualizer",
    "waiting": "Waiting",
    "waveform_error": "Error generating the audio waveform",
    "web": "Web",
    "workflow_deleted_successfully": "Workflow deleted successfully",
    "workflows": "Workflows",
    "yes": "Yes",
    "you_can_create_link": "You can create a public link to collect responses online."
  },
  "initiative": {},
  "features": {},
  "translation": {}
} as const;
